// External
import moment from "moment";
import _ from "lodash";

export const getTemplateVersionHistoryColumnList = () => {
  return [
    {
      id: "updatedBy",
      label: "Teacher",
      hideTooltip: true,
      visible: true,
      alignment: "left",
      type: "TEXTCOLUMN",
      style: { width: "50%" },
    },
    {
      id: "updatedAt",
      label: "Updated at",
      hideTooltip: true,
      visible: true,
      alignment: "left",
      type: "TEXTCOLUMN",
      style: { width: "50%" },
    },
  ];
};

export const getTemplateVersionChangesColumnList = () => {
  return [
    {
      id: "section",
      label: "Section",
      hideTooltip: true,
      visible: true,
      alignment: "left",
      type: "TEXTCOLUMN",
      style: { width: "10%" },
    },
    {
      id: "path",
      label: "Path",
      hideTooltip: true,
      visible: true,
      alignment: "left",
      type: "TEXTCOLUMN",
      style: { width: "40%" },
    },
    {
      id: "field",
      label: "Field",
      hideTooltip: true,
      visible: true,
      alignment: "left",
      type: "TEXTCOLUMN",
      style: { width: "10%" },
    },
    {
      id: "action",
      label: "Action",
      hideTooltip: true,
      visible: true,
      alignment: "left",
      type: "TEXTCOLUMN",
      style: { width: "10%" },
    },
    {
      id: "oldValue",
      label: "Old value",
      hideTooltip: true,
      visible: true,
      alignment: "left",
      type: "TEXTCOLUMN",
      style: { width: "15%" },
    },
    {
      id: "newValue",
      label: "New value",
      hideTooltip: true,
      visible: true,
      alignment: "left",
      type: "TEXTCOLUMN",
      style: { width: "15%" },
    },
  ];
};

export const getTemplateVersionHistoryFeedData = ({ data }) => {
  if (!data || !_.isArray(data)) {
    return [];
  }

  return _.map(data, item => ({
    id: _.get(item, "id"),
    updatedBy: _.get(item, "updatedBy", "-"),
    updatedAt: _.get(item, "updatedAt")
      ? moment(_.get(item, "updatedAt")).format("DD MMM YYYY hh:mm A")
      : "-",
  }));
};

export const getTemplateVersionChangesFeedData = ({ data }) => {
  if (!data || !_.isArray(data)) {
    return [];
  }

  return _.map(data, (item, index) => ({
    id: index,
    section: _.get(item, "section", "-"),
    path: _.get(item, "path", "-"),
    field: _.get(item, "field", "-"),
    action: _.get(item, "action", "-"),
    oldValue: _.get(item, "oldValue", "-"),
    newValue: _.get(item, "newValue", "-"),
  }));
};
